module.exports = __webpack_public_path__ + "static/img/user.047e301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/user.png
// module id = Ctr9
// module chunks = 1